import React, { ReactNode } from "react";
import styles from "./IsDesktop.module.scss";
import classnames from "classnames";

const IsDesktop = ({ children }: IsDesktopProps) => (
  <>
    {children &&
      React.Children.map(children, (child: any) =>
        React.cloneElement(child, {
          className: classnames(styles.isDesktop, child.props.className)
        })
      )}
  </>
);

export default IsDesktop;

interface IsDesktopProps {
  children: ReactNode;
}
